import React from "react";
import { Helmet } from "react-helmet";
const DigiMarketingportfolioHelmet= ({ title }) => {
  return (
    <Helmet>
      <title>
        Digital Marketing Portfolio | Digious Solutions
      </title>
      <meta
        name="description"
        content="Discover Digious Solutions’ digital marketing and creative design portfolio featuring impactful branding and visual content engineered to boost brand visibility and engagement."
      />
    </Helmet>
  );
};

export default DigiMarketingportfolioHelmet;
